import { TOOL_TITLES } from '@risksmart-app/shared/ai/toolTitles';

import { toTitleCase } from '@/utils/utils';

/**
 * Strip the Agent SDK's `mcp__<server>__` namespacing to the bare tool name.
 * Bare tool names contain no `__`, so everything after the second `__` is the name
 * (e.g. `mcp__risksmart__get_risk_by_id` → `get_risk_by_id`). Names without the
 * prefix (built-in / non-MCP tools) or malformed short names are returned
 * unchanged so the label is never blank — `toTitleCase` then prettifies whatever
 * remains.
 */
const bareToolName = (rawName: string): string => {
  const segments = rawName.split('__');

  return rawName.startsWith('mcp__') && segments.length >= 3
    ? segments.slice(2).join('__')
    : rawName;
};

/**
 * Human-readable label for an agent tool call shown in the "Used N tools" panel.
 * Prefers the curated title (the same shared `TOOL_TITLES` map the MCP server
 * exposes to external clients), falling back to a prettified form of the bare name
 * so an untitled or newly-added tool never renders as a raw `mcp__…` string.
 */
export const toolLabel = (rawName: string): string => {
  const bare = bareToolName(rawName);

  return TOOL_TITLES[bare] ?? toTitleCase(bare);
};
